const perguntas = [
  //Pergunta 0 A vos côtès
        [
          {
            pergunta: 'Depuis quand le service À Vos Côtés existe-t-il à Bonnevoie?',
            opcoesResposta: ['A/ Depuis 2021', 'B/ Depuis 1921'],
            respostaCorreta: 'A/ Depuis 2021',
          }, 
          {
            pergunta: 'Dans quels quartiers de Luxembourg-Ville les équipes À Vos Côtés sont-elles à votre service?',
            opcoesResposta: ['A/ Bonnevoie, Gare, et Ville-Haute', 'B/ Kirchberg et Limpertsberg'],
            respostaCorreta: 'A/ Bonnevoie, Gare, et Ville-Haute',
          }, 
        {
            pergunta: 'Quel est l\'objectif du service À vos côtés?', 
            opcoesResposta: ['A/ Rassurer les résidents et les passants', 'B/ Organiser des visites touristiques dans le quartier de Bonnevoie'],
            respostaCorreta: 'A/ Rassurer les résidents et les passants',
          }, 
        {
            pergunta: 'De quelle couleur est la tenue des membres de À vos côtés?', 
            opcoesResposta: ['A/ Rouge', 'B/ Vert'],
            respostaCorreta: 'B/ Vert',
        }, 
        {
          pergunta: 'À Vos Côtés est un service proposé par l\'association:', 
          opcoesResposta: ['A/ Inter-Actions', 'B/ CLAE'],
          respostaCorreta: 'A/ Inter-Actions',
      }, 
    
      
    
        ],


  //Pergunta 1 Rotondes
    
      [
        
        {
          pergunta: 'Quand les Rotondes ont-elles été construites?',
          opcoesResposta: ['A/ 1975', 'B/ 1875'],
          respostaCorreta: 'B/ 1875',
        }, 
       {
          pergunta: 'Les Rotondes dans le passé étaient…',
          opcoesResposta: ['A/ Un atelier de réparation pour les locomotives à vapeur', 'B/ Un studio d\'art'],
          respostaCorreta: 'A/ Un atelier de réparation pour les locomotives à vapeur',
        },
        
        { 
          pergunta: 'Quel rôle a joué Rotondes en 2007?',
          opcoesResposta: ['A/ C\’était le quartier général de Luxembourg capitale européenne de la culture', 'B/ C\’était le quartier général de Luxembourg capitale Européenne de l\’agriculture'],
          respostaCorreta: 'A/ C\’était le quartier général de Luxembourg capitale européenne de la culture',
        }, 
        {
          pergunta: 'Quel chanteur belge célèbre a utilisé la console de son que Rotondes utilise dans sa salle de concert, le Klub?',
          opcoesResposta: ['A/ Jacques Brel', 'B/ Stromae'],
          respostaCorreta: 'B/ Stromae',
        },  
        {
          pergunta: 'Pourquoi aller à Rotondes aujourd\’hui?',
          opcoesResposta: ['A/ Pour assister à des spectacles, des concerts, des expositions d\'art, …', 'B/ Pour regarder les trains passer'],
          respostaCorreta: 'A/ Pour assister à des spectacles, des concerts, des expositions d\'art, …',
        }, 
      ],

  //Pergunta 2 Radio Ara 

      [ 
        {
          pergunta: 'En quelle année Radio ARA a-t-elle été officiellement créée?',
          opcoesResposta: ['A/ 1992', 'B/ 1892'],
          respostaCorreta: 'A/ 1992',
         },  
          
         {
          pergunta: 'En combien de langues Radio Ara diffuse-t-elle, en 2024, un programme régulier?',
          opcoesResposta: ['A/ En 3 langues', 'B/ En 15 langues'],
          respostaCorreta: 'B/ En 15 langues',
         }, 
         
          {
           pergunta: 'A qui s’adresse Radio Ara?',
           opcoesResposta: ['A/ Tout public', 'B/ Les enfants du quartier de Bonnevoie'],
           respostaCorreta: 'A/ Tout public',
         }, 
      
          {
          pergunta: 'Dans quelle langue radio Ara ne diffuse-t-elle pas de programme (pour l\'instant)?',
          opcoesResposta: ['A/ Inuktitut', 'B/ Indien'],
          respostaCorreta: 'A/ Inuktitut',
         }, 
            
         {
           pergunta: 'Est-il possible de proposer une émission à Radio Ara?',
           opcoesResposta: ['A/ Oui, Radio Ara accueille les nouvelles idées et forme les animateurs', 'B/ Non'],
           respostaCorreta: 'A/ Oui, Radio Ara accueille les nouvelles idées et forme les animateurs',
          }, 
    
     ],


  //Pergunta 3 Trois CL

     //Pergunta 6  Mir wëllen iech ons 
  
     [ 
      {
       pergunta: 'En quelle année Mir wëllen iech ons Heemecht weisen a-t-elle été fondée?',
       opcoesResposta: ['A/ En octobre 2015 en réponse à l’arrivée d’un grand nombre de réfugiés au Luxembourg', 'B/ À la fin de la seconde Guerre Mondiale'],
       respostaCorreta: 'A/ En octobre 2015 en réponse à l’arrivée d’un grand nombre de réfugiés au Luxembourg',
     },  
     
     {
       pergunta: 'Quel musicien luxembourgeois connu est un des membres fondateurs de Mir wëllen iech ons Heemecht weisen?',
       opcoesResposta: ['A/ Serge Tonnar', 'B/ Fausti'],
       respostaCorreta: 'A/ Serge Tonnar',
     },
      
     {
       pergunta: 'Que veut dire Mir wëllen iech ons Heemecht weisen?',
       opcoesResposta: ['A/ Nous voulons vous montrer notre patrie', 'B/ Nous voulons vous montrer notre fabrique'],
       respostaCorreta: 'A/ Nous voulons vous montrer notre patrie',
     },
 
    {
       pergunta: 'Mir wëllen iech ons Heemecht weisen se trouve…',
       opcoesResposta: ['A/ À la Banannefabrik', 'B/ À l’Institut National des Langues Luxembourg'],
       respostaCorreta: 'A/ À la Banannefabrik',
     }, 
     {
       pergunta: 'Quelle patrie souhaite montrer aux nouveaux arrivants Mir wëllen iech ons Heemecht weisen?',
       opcoesResposta: ['A/ La Grande Région', 'B/ Le Grand-Duché de Luxembourg'],
       respostaCorreta: 'B/ Le Grand-Duché de Luxembourg',
     },  
   

 ],
 //Pergunta 4 Maskénada
 
        [ 
          {
            pergunta: 'Dans quel bâtiment se trouve Maskénada?',
            opcoesResposta: ['A/ La Banannefabrik', 'B/ Le centre sociétaire de Bonnevoie'],
            respostaCorreta: 'A/ La Banannefabrik',
          },
          {
            pergunta: 'Maskénada est…?',
            opcoesResposta: ['A/ Une chanson brésilienne populaire', 'B/ Un collectif d\'artistes du Luxembourg'],
            respostaCorreta: 'B/ Un collectif d\'artistes du Luxembourg',
          }, 

          {
            pergunta: 'Maskénada a été fondée en…?',
            opcoesResposta: ['A/ En 1995, quand le Luxembourg fut Capitale Européenne de la Culture', 'B/ En 2015'],
            respostaCorreta: 'A/ En 1995, quand le Luxembourg fut Capitale Européenne de la Culture',
          },
          {
            pergunta: 'Maskénada, en 2024, dans le cadre du festival off d\'Avignon en France, a présenté la performance…',
            opcoesResposta: ['A/ Corps au bout du monde', 'B/ Corps au bout de la nuit'],
            respostaCorreta: 'A/ Corps au bout du monde',
          }, 
          {
            pergunta: 'Maskénada rassemble des artistes issus:',
            opcoesResposta: ['A/ Du théâtre, de la musique, du cinéma, de la danse, de la performance', 'B/ Du conservatoire de la Ville de Luxembourg'],
            respostaCorreta: 'A/ Du théâtre, de la musique, du cinéma, de la danse, de la performance',
          }, 
        ],
    //Pergunta 5 Kulturpass

      
        [
          {
            pergunta: 'Combien coûte un billet d\'entrée à un événement culturel avec le Kulturpass?',
            opcoesResposta: ['A/ 1,50€', 'B/ 15€'],
            respostaCorreta: 'A/ 1,50€',
          },
          
        {
            pergunta: 'Kulturpass permet aux personnes à revenu modeste de participer à la vie culturelle luxembourgeoise',
            opcoesResposta: ['A/ Cette carte est gratuite, personnelle et valable 2 ans', 'B/ Cette carte est payante et renouvelable chaque année'],
            respostaCorreta: 'A/ Cette carte est gratuite, personnelle et valable 2 ans',
          }, 
  
         
          {
            pergunta: 'Quand le Kulturpass a-t-il été lancé?',
            opcoesResposta: ['A/ En 2010', 'B/ En 1980'],
            respostaCorreta: 'A/ En 2010',
          }, 
            
         {
            pergunta: 'Où se trouve le bureau de l’asbl Cultur’all / Kulturpass?',
            opcoesResposta: ['A/ À la Banannefabrik, à Bonnevoie, 12 rue du Puits', 'B/ À Luxembourg City Tourist Office, 30 Pl. Guillaume, Ville-Haute'],
            respostaCorreta: 'A/ À la Banannefabrik, à Bonnevoie, 12 rue du Puits',
          }, 
           
          {
            pergunta: 'Un détenteur du Kulturpass bénéficie aussi…',
            opcoesResposta: ['A/ De l\'entrée gratuite dans les musées partenaires', 'B/ De 2 entrées gratuites au Kinépolis'],
            respostaCorreta: 'A/ De l\'entrée gratuite dans les musées partenaires' ,
          }, 
      ], 
  //Pergunta 6 trois cl
  
      [ 
        {
          pergunta: 'Comment s\'appelle l\'événement de Trois C-L qui se déroule tous les 3 du mois?',
          opcoesResposta: ['A/ Le 3 du TROIS', 'B/ Le Un, Deux, Trois de moi et toi'],
          respostaCorreta: 'A/ Le 3 du TROIS',
        },
        {
          pergunta: 'Dans quel bâtiment, à Bonnevoie, se trouve Trois C-L?',
          opcoesResposta: ['A/ À la Banannefabrik', 'B/ À Rotondes'],
          respostaCorreta: 'A/ À la Banannefabrik',
        }, 
        {
          pergunta: 'Quelle forme de pratique artistique soutient Trois C-L au niveau national et international?',
          opcoesResposta: ['A/ La danse contemporaine', 'B/ La salsa'],
          respostaCorreta: 'A/ La danse contemporaine',
        },
        {
          pergunta: 'Comment s\'appelle un des programmes de stage de Trois C-L?',
          opcoesResposta: ['A/ Young movers', 'B/ Le remover'],
          respostaCorreta: 'A/ Young movers',
        }, 
          
        {
          pergunta: 'Trois C-L, c\'est…',
          opcoesResposta: ['A/ La maison pour la danse', 'B/ La maison des fruits et légumes'],
          respostaCorreta: 'A/ La maison pour la danse',
        }, 
   
    ],

    
  //Pergunta 7 vollekskichen
    [
      {
        pergunta: 'Le prix d\'un menu (soupe, café/thé, dessert compris) à la Vollekskichen, en 2025, est de…',
        opcoesResposta: ['A/ 7€', 'B/ 10€'],
        respostaCorreta: 'A/ 7€',
      },
      {
        pergunta: 'La Vollekskichen est ouverte…',
        opcoesResposta: ['A/ 7 jours sur 7, 365 jours par an', 'B/ Du lundi au jeudi'],
        respostaCorreta: 'A/ 7 jours sur 7, 365 jours par an',
      },
      {
        pergunta: 'Qui peut manger à la Vollekskichen?',
        opcoesResposta: ['A/ Tout le monde peut y manger', 'B/ Les adhérents du club Vollekskichen'],
        respostaCorreta: 'A/ Tout le monde peut y manger',
      },
      {
        pergunta: 'Peut-on amener son chien à la Vollekskichen?',
        opcoesResposta: ['A/ Oui, s’il reste calme', 'B/ Non, ici, on n’aime que les chats'],
        respostaCorreta: 'A/ Oui, s’il reste calme',
      },
      {
        pergunta: 'Combien de repas sont-ils servis chaque midi environ?',
        opcoesResposta: ['A/ Jusqu’à 500', 'B/ Jusqu’à 200'],
        respostaCorreta: 'B/ Jusqu’à 200',
      },
    
      ],
    // Pergunta 8 Doktore vun der Welt  
    [
      {
        pergunta: 'Doktere vun der Welt a un centre d’Accueil, de Soins et d’Orientation (CASO)...',
        opcoesResposta: ['A/ À Bonnevoie et à Esch-sur-Alzette', 'B/ À Diekirch et Vianden'],
        respostaCorreta: 'A/ À Bonnevoie et à Esch-sur-Alzette',
      },
      {
        pergunta: 'Le centre du logo de Doktere vun der Welt représente...',
        opcoesResposta: ['A/ Une maison avec un toit', 'B/ Un oiseau'],
        respostaCorreta: 'B/ Un oiseau',
      },
      {
        pergunta: 'Le premier objectif de Doktere vun der Welt est…',
        opcoesResposta: ['A/ De prendre en charge les personnes ne sachant pas nager', 'B/ De soigner toute personne n’ayant plus accès à des soins médicaux'],
        respostaCorreta: 'B/ De soigner toute personne n’ayant plus accès à des soins médicaux',
        },
      {
        pergunta: 'Doktere vun der Welt fonctionne grâce à…',
        opcoesResposta: ['A/ Son personnel salarié uniquement', 'B/ Un très grand nombre de bénévoles'],
        respostaCorreta: 'B/ Un très grand nombre de bénévoles',
        },  

      {
        pergunta: 'Doktere vun der Welt Luxembourg fait partie du réseau international créé en 1980 par Médecins du Monde France.',
        opcoesResposta: ['A/ Vrai', 'B/ Faux'],
        respostaCorreta: 'A/ Vrai',
      },  
    
      ], 

//Pergunta 10 Gero
    [
      {
        pergunta: 'GERO (Kompetenzzenter fir den Alter) s’adresse principalement',
        opcoesResposta: ['A/ Aux familles monoparentales', 'B/ Aux personnes âgées et, de façon générale, à tous ceux qui s’intéressent au thème du vieillissement réussi'],
        respostaCorreta: 'B/ Aux personnes âgées et, de façon générale, à tous ceux qui s’intéressent au thème du vieillissement réussi',
      },
      {
        pergunta: 'Le mot GERO est dérivé de quel mot concernant les personnes âgées?',
        opcoesResposta: ['A/ Du terme gérontologie, la science qui étudie les effets du vieillissement', 'B/ De Geronimo, le protecteur des séniors'],
        respostaCorreta: 'A/ Du terme gérontologie, la science qui étudie les effets du vieillissement',
      },
      {
        pergunta: 'GERO souhaite notamment…',
        opcoesResposta: ['A/ Sensibiliser / orienter / informer le public sur les sujets liés à l‘âge', 'B/ Proposer des excursions intergénérationnelles en famille'],
        respostaCorreta: 'A/ Sensibiliser / orienter / informer le public sur les sujets liés à l‘âge',
        },


      {
        pergunta: 'GERO se trouve 1, Dernier Sol, à Bonnevoie, près de la gare.',
        opcoesResposta: ['A/ Vrai', 'B/ Faux'],
        respostaCorreta: 'A/ Vrai',
        },

      {
        pergunta: 'GERO s’engage pour la diversité, la participation, la progression, l’innovation.',
        opcoesResposta: ['A/ Vrai', 'B/ Faux'],
        respostaCorreta: 'A/ Vrai',
        },
     
    
      ], 
    //Pergunta 9 digital inclusion
    [
      {
        pergunta: 'Quand l’association Digital Inclusion a-t-elle été créée?',
        opcoesResposta: ['A/ 2016', 'B/ 1996'],
        respostaCorreta: 'A/ 2016',
      },
      {
        pergunta: 'Quels appareils électroniques Digital Inclusion rénove-t-elle?',
        opcoesResposta: ['A/ Les ordinateurs et les smartphones', 'B/ Les enceintes Bluetooth et les écouteurs sans fil'],
        respostaCorreta: 'A/ Les ordinateurs et les smartphones',
      },
      {
        pergunta: 'Qui peut recevoir un laptop rénové par Digital Inclusion?',
        opcoesResposta: ['A/ Les résidents du Luxembourg bénéficiant des aides sociales et les réfugiés', 'B/ Les résidents habitant à Bonnevoie depuis plus de 5 ans'],
        respostaCorreta: 'A/ Les résidents du Luxembourg bénéficiant des aides sociales et les réfugiés',
        },
      {
        pergunta: 'En combien de langues, en 2024, sont donnés les cours “digital skills” proposés par Digital Inclusion?',
        opcoesResposta: ['A/ En français uniquement', 'B/ En 10 langues'],
        respostaCorreta: 'B/ En 10 langues',
        }, 
      {
        pergunta: 'Depuis août 2024, les locaux de Digital Inclusion se trouvent',
        opcoesResposta: ['A/ 1, Dernier Sol, à Bonnevoie (près de la gare)', 'B/ Au ministère de la Digitalisation'],
        respostaCorreta: 'A/ 1, Dernier Sol, à Bonnevoie (près de la gare)',
        }, 
    
      ],
   

      

      //Pergunta 11 Centre Culturel et centre sociétaire
      [
        {
          pergunta: 'L’Entente des Sociétés de Bonnevoie édite 3 fois par an une gazette qui s’appelle',
          opcoesResposta: ['A/ Les Nouvelles de Bonnevoie', 'B/ Si Bonnevoie m’était conté'],
          respostaCorreta: 'A/ Les Nouvelles de Bonnevoie',
          },
        
          {
            pergunta: 'L’Entente des Sociétés de Bonnevoie regroupe',
            opcoesResposta: ['A/ Des associations ayant leur siège social à Bonnevoie-Sud et Bonnevoie-Nord/Verlorenkost (ou une partie de leurs activités à Bonnevoie)', 'B/ Les commerçants du quartier de Bonnevoie'],
            respostaCorreta: 'A/ Des associations ayant leur siège social à Bonnevoie-Sud et Bonnevoie-Nord/Verlorenkost (ou une partie de leurs activités à Bonnevoie)',
          },
  
          {
            pergunta: 'Les associations membres de l’Entente des Sociétés de Bonnevoie bénéficient, notamment...',
            opcoesResposta: ['A/ D’une location gratuite du Centre Culturel de Bonnevoie par an pour leur événement', 'B/ D’un accès gratuit à la piscine'],
            respostaCorreta: 'A/ D’une location gratuite du Centre Culturel de Bonnevoie par an pour leur événement',
          },
          {
            pergunta: 'Le numéro 1 du périodique Nouvelles de Bonnevoie édité par l’Entente des Sociétés de Bonnevoie est sorti...',
            opcoesResposta: ['A/ En 1980 (tirage 5.500 exemplaires)', 'B/ En 1952 lors de la fondation de l’Entente des Sociétés de Bonnevoie'],
            respostaCorreta: 'A/ En 1980 (tirage 5.500 exemplaires)',
          },
          {
            pergunta: 'Le siège de l’Entente des Sociétés de Bonnevoie est situé au Centre Culturel à Bonnevoie au 2, rue des Ardennes à Bonnevoie.',
            opcoesResposta: ['A/ Vrai', 'B/ Faux'],
            respostaCorreta: 'A/ Vrai',
            },
        
        ], 

      [
          //Pergunta 12 Amicale des français
          {
            pergunta: 'Depuis quand l’Amicale des Français au Luxembourg existe-t-elle?',
            opcoesResposta: ['A/ Depuis 1998', 'B/ Depuis 1962'],
            respostaCorreta: 'A/ Depuis 1998',
            },
            
          {
            pergunta: 'Quelles sont les activités de l’Amicale des Français au Luxembourg?',
            opcoesResposta: ['A/ Excursions, soirées dansantes, pétanque, barbecue, conférences', 'B/ Étudier la langue française'],
            respostaCorreta: 'A/ Excursions, soirées dansantes, pétanque, barbecue, conférences',
          },
         
          {
            pergunta: 'Il n’y a que des Français à l’Amicale des Français au Luxembourg.',
            opcoesResposta: ['A/ Faux, l’Amicale accueille les francophones de différentes nationalités', 'B/ Vrai'],
            respostaCorreta: 'A/ Faux, l’Amicale accueille les francophones de différentes nationalités',
            },
  
          {
            pergunta: 'L’Amicale des Français au Luxembourg organise un apéro convivial…',
            opcoesResposta: ['A/ Le premier jeudi de chaque mois', 'B/ Le deuxième mardi de chaque mois'],
            respostaCorreta: 'A/ Le premier jeudi de chaque mois',
            },  
  
          {
            pergunta: 'Combien coûte la cotisation annuelle de l’Amicale des Français au Luxembourg en 2024?',
            opcoesResposta: ['A/ 15€ par personne', 'B/ 25€ par personne'],
            respostaCorreta: 'A/ 15€ par personne',
            },  
        
      
        ],   
        
      //  13 Mémoires en voyage
      [
        {
          pergunta: 'Quel est l’outil au cœur des activités de Mémoires en voyage?',
          opcoesResposta: ['A/ Le récit de vie', 'B/ La chanson'],
          respostaCorreta: 'A/ Le récit de vie',
          },
        {
          pergunta: 'Quelle suite de mots est à l’opposé des valeurs de Mémoires en voyage?',
          opcoesResposta: ['A/ Indifférence, oubli, solitude', 'B/ Compassion, respect, inclusion'],
          respostaCorreta: 'A/ Indifférence, oubli, solitude',
          },
        {
          pergunta: 'Quel est l’objectif de Mémoires en voyage?',
          opcoesResposta: ['A/ Tisser des liens entre générations et cultures', 'B/ Publier des livres de voyage'],
          respostaCorreta: 'A/ Tisser des liens entre générations et cultures',
       
        },
        {
          pergunta: 'Quel est le public cible de Mémoires en voyage?',
          opcoesResposta: ['A/ Les aînés', 'B/ Les enfants de 0 à 2 ans'],
          respostaCorreta: 'A/ Les aînés',
        },
        {
          pergunta: 'Cette activité ne fait pas partie des activités de Mémoires en voyage',
          opcoesResposta: ['A/ Réaliser des expositions', 'B/ Organiser des consultations médicales en ligne'],
          respostaCorreta: 'B/ Organiser des consultations médicales en ligne',
          },
       
      
        ], 

      //Pergunta 14
      [
        {
          pergunta: 'En quelle année Bouneweger Musek a-t-elle été fondée?',
          opcoesResposta: ['A/ 1898', 'B/ 1998'],
          respostaCorreta: 'A/ 1898',
        },
        {
          pergunta: 'À quelle saison Bouneweger Musek joue-t-elle son concert de gala?',
          opcoesResposta: ['A/ L’hiver', 'B/ L’été'],
          respostaCorreta: 'A/ L’hiver',
        },

        {
          pergunta: 'Quelle marche traditionnelle Bouneweger Musek joue-t-elle lors de la kermesse de Bonnevoie en juillet et à la Schueberfouer en août/septembre?',
          opcoesResposta: ['A/ La Hämmelsmarsch', 'B/ La marche de la Schueberfouer'],
          respostaCorreta: 'A/ La Hämmelsmarsch',
          },
        {
          pergunta: 'Comment se nomme la fanfare des jeunes de Bouneweger Musek?',
          opcoesResposta: ['A/ Fanfare Prince Henri', 'B/ Fanfare Princesse Stéphanie'],
          respostaCorreta: 'A/ Fanfare Prince Henri',
          },
          {
            pergunta: 'Quelle tradition les jeunes de Bouneweger Musek ont-ils depuis plus de 40 ans?',
            opcoesResposta: ['A/ Jouer des cantiques de Noël en ville pour une œuvre caritative', 'B/ Slammer en ville pour une œuvre caritative'],
            respostaCorreta: 'A/ Jouer des cantiques de Noël en ville pour une œuvre caritative',
            },
      
        ],    
        
    //Pergunta 15 infoMann
    [
      {
        pergunta: 'Depuis quand le service infoMann existe-t-il?',
        opcoesResposta: ['A/ Depuis 2012', 'B/ Depuis 2022'],
        respostaCorreta: 'A/ Depuis 2012',
      },
      {
        pergunta: 'A qui infoMann s’adresse-t-il?',
        opcoesResposta: ['A/ Les hommes et les garçons', 'B/ Les hommes et les femmes'],
        respostaCorreta: 'A/ Les hommes et les garçons',
      }, 
      {
        pergunta: 'Que propose infoMann?',
        opcoesResposta: ['A/ Des consultations et des interventions pédagogiques', 'B/ Des cours de langues'],
        respostaCorreta: 'A/ Des consultations et des interventions pédagogiques',
      },
      {
        pergunta: 'Un homme peut consulter infoMann en cas de conflit conjugal, de violence et de violence domestique, pour toutes questions liées à la gestion des émotions, à la masculinité et à la parentalité.',
        opcoesResposta: ['A/ Vrai', 'B/ Faux'],
        respostaCorreta: 'A/ Vrai',
      },
      {
        pergunta: 'InfoMann se trouve désormais...',
        opcoesResposta: ['A/ À Hollerich (39, rue de Bouillon)', 'B/ À Bonnevoie (5, rue du Couvent)'],
        respostaCorreta: 'A/ À Hollerich (39, rue de Bouillon)',
      },
  
    ],   
//

   //Pergunta 16 NUECHTIGAILECHER
      [
        {
          pergunta:'Depuis quand la chorale Bouneweger Nuechtigailercher existe-t-elle?',
          opcoesResposta: ['A/ 1981', 'B/ 2021'],
          respostaCorreta: 'A/ 1981',
        },
        {
          pergunta: 'À partir de quel âge la chorale Bouneweger Nuechtigailercher accueille-t-elle les enfants?',
          opcoesResposta: ['A/ 12 ans', 'B/ 6 ans'],
          respostaCorreta: 'B/ 6 ans',
        },
        {
          pergunta: 'À la veille de quelle fête importante Bouneweger Nuechtigailercher chante-t-elle à l’église paroissiale?',
          opcoesResposta: ['A/ Noël', 'B/ La fête nationale'],
          respostaCorreta: 'A/ Noël',
          },
        {
          pergunta: 'Quel jour a lieu les répétitions de la chorale Bouneweger Nuechtigailercher?',
          opcoesResposta: ['A/ Le mercredi', 'B/ Le dimanche'],
          respostaCorreta: 'A/ Le mercredi',
          },
        {
          pergunta: 'Où ont lieu les répétitions de la chorale Bouneweger Nuechtigailercher?',
          opcoesResposta: ['A/ Au foyer paroissial à Bonnevoie', 'B/ Au Hall Omnisports Bonnevoie'],
          respostaCorreta: 'A/ Au foyer paroissial à Bonnevoie',
          },
       
      
        ], 
  
   //Pergunta 17 DANZSPORTCLUB
   [
    {
      pergunta: 'En 2024, Danzsportclub Rout-Wäiss-Blo Lëtzebuerg a fêté ses…',
      opcoesResposta: ['A/ 50 ans', 'B/ 100 ans'],
      respostaCorreta: 'A/ 50 ans',
    },
    {
      pergunta: 'A quoi font référence les 3 couleurs Rout, Wäiss, Blo dans le nom Danzsportclub Rout-Wäiss-Blo Lëtzebuerg?',
      opcoesResposta: ['A/ Au drapeau rouge, blanc, bleu du Luxembourg', 'B/ Au drapeau bleu, blanc, rouge de la France'],
      respostaCorreta: 'A/ Au drapeau rouge, blanc, bleu du Luxembourg',
    },
    {
      pergunta: 'Quelle danse pratique-t-on à Danzsportclub Rout-Wäiss-Blo Lëtzebuerg?',
      opcoesResposta: ['A/ La danse sportive et de compétition', 'B/ La danse folklorique'],
      respostaCorreta: 'A/ La danse sportive et de compétition',
    },
    {
      pergunta: 'Quelle compétition organise Danzsportclub Rout-Wäiss-Blo Lëtzebuerg chaque année?',
      opcoesResposta: ['A/ La golden lady trophy', 'B/ La Silver Cup'],
      respostaCorreta: 'A/ La golden lady trophy',
      },
  {
      pergunta: 'Quel est le surnom de la salle de répétition de Danzsportclub Rout-Wäiss-Blo Lëtzebuerg?',
      opcoesResposta: ['A/ La cathédrale', 'B/ Le joyau '],
      respostaCorreta: 'A/ La cathédrale',
      },
  
    ], 
   // 18 L'Associazione PassaParola
   [
    {
      pergunta: 'Paola CAIRO et Maria Grazia GALATI sont les journalistes de PassaParola Media Group.',
      opcoesResposta: ['A/ Vrai', 'B/ Faux'],
      respostaCorreta: 'A/ Vrai',
    },
    {
      pergunta: 'Quel est le nom de la revue de PassaParola Media Group?',
      opcoesResposta: ['A/ PassaParola Magazine WEB', 'B/ Les Nouvelles de Bonnevoie'],
      respostaCorreta: 'A/ PassaParola Magazine WEB',
    },
    {
      pergunta: 'Quel film a été réalisé par PassaParola Media Group?',
      opcoesResposta: ['A/ Journal intime (Caro diario)', 'B/ L’Arrivée de la Jeunesse'],
      respostaCorreta: 'B/ L’Arrivée de la Jeunesse',
      },
    {
      pergunta: 'Sur quelle radio luxembourgeoise l’émission Voices by PassaParola est-elle diffusée?',
      opcoesResposta: ['A/ Radio ARA', 'B/ RTL'],
      respostaCorreta: 'A/ Radio ARA',
      },
      {
        pergunta: 'Quel livre de PassaParola Editions raconte l’histoire des Italiens au Grand-Duché?',
        opcoesResposta: ['A/ Tanti italiani fa… in Lussemburgo', 'B/ Lussemburgo'],
        respostaCorreta: 'A/ Tanti italiani fa… in Lussemburgo',
        },
  
    ], 
    
  //Pergunta 19 DËSCH-TENNIS UNION LËTZEBUERG
  [
    {
      pergunta: 'Le Dësch-Tennis Union Lëtzebuerg est issu de la fusion du D.T. Bonnevoie et du D.T. Hollerich.',
      opcoesResposta: ['A/ Vrai, en 2006', 'B/ Faux'],
      respostaCorreta: 'A/ Vrai, en 2006',
    },
    {
      pergunta: 'Combien pèse une balle de tennis de table de Dësch-Tennis Union Lëtzebuerg?',
      opcoesResposta: ['A/ 2,7 grammes (poids standard)', 'B/ Cela dépend de la catégorie d’âge'],
      respostaCorreta: 'A/ 2,7 grammes (poids standard)',
    },
    {
      pergunta: 'Filles et garçons peuvent jouer dans une même équipe.',
      opcoesResposta: ['A/ Vrai, les équipes mixtes sont possibles pour toutes les catégories d’âge', 'B/ Faux'],
      respostaCorreta: 'A/ Vrai, les équipes mixtes sont possibles pour toutes les catégories d’âge',
      },
         
    {
      pergunta: 'Quelle vitesse peut atteindre une balle de tennis de table?',
      opcoesResposta: ['A/ 110 km/h', 'B/ 10 km/h'],
      respostaCorreta: 'A/ 110 km/h',
      },    
    {
      pergunta: 'Depuis quand Dësch-Tennis Union Lëtzebuerg existe-t-elle?',
      opcoesResposta: ['A/ Depuis 1939', 'B/ Depuis 1989'],
      respostaCorreta: 'A/ Depuis 1939',
      }, 
  
    ], 
// 20 Coordination Nord-Sud
[
  {
    pergunta: 'Coopération Nord-Sud organise chaque année une course à Bonnevoie…',
    opcoesResposta: ['A/ Le K-run', 'B/ Le DKV-Urban Trail'],
    respostaCorreta: 'A/ Le K-run',
  },
  {
    pergunta: 'Coopération Nord-Sud a été créée au Luxembourg en…',
    opcoesResposta: ['A/ 2011', 'B/ 2021'],
    respostaCorreta: 'A/ 2011',
  },
  {
    pergunta: 'Coopération Nord-Sud est une ONG spécialisée dans le domaine de l’éducation et de la formation.',
    opcoesResposta: ['A/ Vrai', 'B/ Faux'],
    respostaCorreta: 'A/ Vrai',
  },
  {
    pergunta: 'La lettre K du K-run organisé par Coopération Nord-Sud fait référence…',
    opcoesResposta: ['A/ Au recueil de nouvelles, Le K, de Dino Buzzati', 'B/ À Korogocho et aux projets accomplis dans le bidonville de Korogocho (Kenya)'],
    respostaCorreta: 'B/ À Korogocho et aux projets accomplis dans le bidonville de Korogocho (Kenya)',
  },
  {
    pergunta: 'Coopération Nord-Sud à une vision participative et centrée sur la personne du développement.',
    opcoesResposta: ['A/ Vrai', 'B/ Faux'],
    respostaCorreta: 'A/ Vrai',
    },

  ], 
// 21 Tennis Club Bonnevoie
[
  {
    pergunta: 'Quel est l’autre sport de raquette proposé par le Tennis Club de Bonnevoie?',
    opcoesResposta: ['A/ Le padel', 'B/ Le squash'],
    respostaCorreta: 'A/ Le padel',
  },
  
  {
    pergunta: 'Le Tennis Club de Bonnevoie a été créé, il y a…',
    opcoesResposta: ['A/ Plus de 30 ans (en 1970)', 'B/ Moins de 30 ans'],
    respostaCorreta: 'A/ Plus de 30 ans (en 1970)',
  },
  
  {
    pergunta: 'Que cultive particulièrement le Tennis Club de Bonnevoie?',
    opcoesResposta: ['A/ L’esprit de famille', 'B/ L’esprit de revanche'],
    respostaCorreta: 'A/ L’esprit de famille',
  },
  
  {
    pergunta: 'Combien de courts de tennis couverts et ouverts sont à disposition des joueurs?',
    opcoesResposta: ['A/ Plus de 10', 'B/ Moins de 10'],
    respostaCorreta: 'A/ Plus de 10',
  },
  {
    pergunta: 'Le Tennis Club de Bonnevoie est fier…',
    opcoesResposta: ['A/ D’avoir remporté la Coupe d’Europe des clubs champions Dames en 2000', 'B/ D’avoir remporté la Coupe d’Europe des clubs champions Hommes en 2000'],
    respostaCorreta: 'A/ D’avoir remporté la Coupe d’Europe des clubs champions Dames en 2000',
  },

  ], 
    //Pergunta 22 FONDATION MAISON DE LA PORTE OUVERTE (SMJ-CAB)
    [
      {
        pergunta: 'À qui s’adresse la maison SMJ-CAB de la Fondation Maison de la Porte Ouverte?',
        opcoesResposta: ['A/ Aux mineurs non-accompagnés arrivant au Luxembourg', 'B/ Aux mineurs accompagnés arrivant au Luxembourg'],
        respostaCorreta: 'A/ Aux mineurs non-accompagnés arrivant au Luxembourg',
        },
   
      {
        pergunta: 'De quelle couleur est la façade de la maison SMJ-CAB de la Fondation Maison de la Porte Ouverte?',
        opcoesResposta: ['A/ Marron', 'B/ Bleu Rouge Blanc'],
        respostaCorreta: 'A/ Marron',
      },
      {
        pergunta: 'La maison SMJ-CAB de la Fondation Maison de la Porte Ouverte est située boulevard Patton...',
        opcoesResposta: ['A/ Au 352, comme l’indicatif du Luxembourg', 'B/ Au 48'],
        respostaCorreta: 'B/ Au 48',
      },
      {
        pergunta: 'Combien de jeunes vivent dans la maison St Martin Jeunes, Centre d’accueil de Bonnevoie?',
        opcoesResposta: ['A/ 10 jeunes', 'B/ 5 jeunes'],
        respostaCorreta: 'B/ 5 jeunes',
        },
      {
        pergunta: 'Quand les jeunes ont-ils emménagé dans la maison SMJ-CAB de la Fondation Maison de la Porte Ouverte?',
        opcoesResposta: ['A/ Le 13 avril 2022', 'B/ Le 20 avril 2024'],
        respostaCorreta: 'A/ Le 13 avril 2022',
        },
    
      ],   
      //23 Ligue Medico-social
      [
        {
          pergunta: 'Combien de centres médico-sociaux la Ligue gère-t-elle au Luxembourg (en 2025)?',
          opcoesResposta: ['A/ 13 centres', 'B/ 26 centres'],
          respostaCorreta: 'A/ 13 centres',
        },
        {
          pergunta: 'La Ligue propose des services...',
          opcoesResposta: ['A/ Sociaux et socio-médicaux', 'B/ Sportifs et artistiques'],
          respostaCorreta: 'A/ Sociaux et socio-médicaux',
        },
        {
          pergunta: 'En 2008, la Ligue a fêté ses 100 ans.',
          opcoesResposta: ['A/ Vrai', 'B/ Faux'],
          respostaCorreta: 'A/ Vrai',
        },
        {
          pergunta: 'Quel est le nom complet de la Ligue?',
          opcoesResposta: ['A/ La Ligue luxembourgeoise de prévention et d’actions médico-sociales', 'B/ La Ligue luxembourgeoise pour la promotion de la santé'],
          respostaCorreta: 'A/ La Ligue luxembourgeoise de prévention et d’actions médico-sociales',
        },
        {
          pergunta: 'La semaine nationale de prévention du surendettement co-organisée par la Ligue a lieu...',
          opcoesResposta: ['A/ Chaque année', 'B/ Tous les 10 ans'],
          respostaCorreta: 'A/ Chaque année',
        },
        
      
      
        ],  
    
      //Pergunta 23 LIGUE FAMILLJEN CENTER
      [
        {
          pergunta: 'Familljen-Center est un service de consultation psychologique. Quelles autres activités le Familljen-Center propose-t-il?',
          opcoesResposta: ['A/ Des activités de groupe et des médiations familiales', 'B/ Des cours de langues'],
          respostaCorreta: 'A/ Des activités de groupe et des médiations familiales',
        },
        {
          pergunta: 'Les enfants entre 5 et 15 ans peuvent être suivis sans leurs personnes de référence à Familljen-Center.',
          opcoesResposta: ['A/ Faux. Les enfants sont toujours reçus en famille que ce soit pour des consultations, des thérapies, des médiations familiales…', 'B/ Vrai'],
          respostaCorreta: 'A/ Faux. Les enfants sont toujours reçus en famille que ce soit pour des consultations, des thérapies, des médiations familiales…',
        },
        {
          pergunta: 'Les parents peuvent consulter Familljen-Center en cas de questions concernant leur enfant à naître et/ou leur enfant intersexe.',
          opcoesResposta: ['A/ Vrai. Ces thématiques figurent parmi les thématiques principales de Familljen-Center', 'B/ Faux'],
          respostaCorreta: 'A/ Vrai. Ces thématiques figurent parmi les thématiques principales de Familljen-Center',
        },
        {
          pergunta: 'Depuis combien d’années Familljen-Center existe-t-il?',
          opcoesResposta: ['A/ Depuis plus de 40 ans. En 1981, l’asbl Consultation et Préparation Familiale a été créée', 'B/ Moins de 40 ans'],
          respostaCorreta: 'A/ Depuis plus de 40 ans. En 1981, l’asbl Consultation et Préparation Familiale a été créée',
        },
        {
          pergunta: 'Les bureaux de Familljen-Center se trouvent à Bonnevoie et…',
            opcoesResposta: ['A/ Au Rollingergrund', 'B/ À Kirchberg'],
            respostaCorreta: 'A/ Au Rollingergrund',
        },
      
        ],  

  // 24 C.F.F.M
  [
    {
      pergunta: 'CFFM signifie…',
      opcoesResposta: ['A/ Cabinet de Formation pour Femmes en Management', 'B/ Centre pour Femmes, Familles et Familles Monoparentales'],
      respostaCorreta: 'B/ Centre pour Femmes, Familles et Familles Monoparentales',
    },
    {
      pergunta: 'Le Centre pour Femmes, Familles et Familles Monoparentales est un service de:',
      opcoesResposta: ['A/ AFP-Solidarité-Famille asbl', 'B/ Femmes en Détresse asbl'],
      respostaCorreta: 'B/ Femmes en Détresse asbl',
    },
    {
      pergunta: 'Le Centre pour Femmes, Familles et Familles Monoparentales s’adresse:',
      opcoesResposta: ['A/ Aux femmes et hommes en situation de monoparentalité', 'B/ Aux filles mineures'],
      respostaCorreta: 'A/ Aux femmes et hommes en situation de monoparentalité',
      },
    {
      pergunta: 'Les services du Centre pour Femmes, Familles et Familles Monoparentales sont',
      opcoesResposta: ['A/ Payants', 'B/ Gratuits'],
      respostaCorreta: 'B/ Gratuits',
      },
    {
      pergunta: 'Le Centre pour Femmes, Familles et Familles Monoparentales reçoit',
      opcoesResposta: ['A/ Sans rendez-vous', 'B/ Sur rendez-vous (je dois prendre rendez-vous par téléphone)'],
      respostaCorreta: 'B/ Sur rendez-vous (je dois prendre rendez-vous par téléphone)',
      },
    ], 

  //Pergunta 25 Multilearn
  [
    {
      pergunta: 'Luxembourg multi-LEARN Institute promeut...',
      opcoesResposta: ['A/ L’apprentissage et le développement en interaction', 'B/ L’apprentissage et le développement à l’intersection'],
      respostaCorreta: 'A/ L’apprentissage et le développement en interaction',
      },

    {
      pergunta: 'Abléck, Unplugged Messages, Wait in sont...',
      opcoesResposta: ['A/ Les noms de 3 projets passés de Luxembourg multi-LEARN Institute', 'B/ Les noms de 3 émoticônes créées par Luxembourg multi-LEARN Institute'],
      respostaCorreta: 'A/ Les noms de 3 projets passés de Luxembourg multi-LEARN Institute',
      },

    {
      pergunta: 'Quel est le moyen de transport privilégié au Luxembourg multi-LEARN Institute?',
      opcoesResposta: ['A/ La voiture', 'B/ Le vélo'],
      respostaCorreta: 'B/ Le vélo',
      }, 

    {
      pergunta: 'Luxembourg multi-LEARN Institute propose…',
      opcoesResposta: ['A/ Des cours de langue', 'B/ Des activités dans le cadre de recherches-interventions'],
      respostaCorreta: 'B/ Des activités dans le cadre de recherches-interventions',
      },

    {
      pergunta: 'Pour Luxembourg multi-LEARN Institute, la diversité est...',
      opcoesResposta: ['A/ Une ressource à valoriser', 'B/ Un obstacle à contourner'],
      respostaCorreta: 'A/ Une ressource à valoriser',
      },
 
   ],         
                
         
      ];

 


export default perguntas;